import { TFunction } from 'i18next';
import { DataImport } from 'graphql-common';
import { IconButtonTypes } from '@lib/components/IconButton/IconButton';
import { TableAction } from '@lib/components/Table/types';

type ActionsMenuArgs = {
  onCancel: (item?: DataImport) => void;
  onDelete: (item?: DataImport) => void;
  t: TFunction<'translation', undefined>;
};

export default function getTableActions({
  onCancel,
  onDelete,
  t,
}: ActionsMenuArgs): TableAction<DataImport>[] {
  return [
    {
      id: 'cancel-action',
      onClick: onCancel,
      icon: 'close',
      type: IconButtonTypes.PrimaryOutlined,
      predictorFnVisible: (item: DataImport) =>
        !!item.backgroundJob?.canCancel.value,
      predictorFnTooltipProps: () => ({
        body: t('cancel-import'),
      }),
    },
    {
      id: 'delete-action',
      onClick: onDelete,
      icon: 'delete',
      type: IconButtonTypes.PrimaryOutlined,
      predictorFnVisible: (item: DataImport) =>
        !item.backgroundJob?.canCancel.value && !!item?.canDestroy.value,
      predictorFnTooltipProps: () => ({
        body: t('delete-from-history'),
      }),
    },
  ];
}
